<p-toast></p-toast>

<app-page-shell>

    <app-page-hero
        eyebrow="Fleet Mobilization"
        title="Salary Rules"
        subtitle="Manage company daily salary rules by truck type for mobilization calculations.">
        <div nav>
            <p-button label="Overview" icon="pi pi-chart-line" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization"></p-button>
            <p-button label="Entries" icon="pi pi-list" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization/entries"></p-button>
            <p-button label="Salary Rules" icon="pi pi-wallet" routerLink="/fleet/mobilization/salary-rules"></p-button>
        </div>
        <div actions>
            <p-button label="New Rule" icon="pi pi-plus" (onClick)="create()"></p-button>
        </div>
    </app-page-hero>

    <app-page-search-panel
        title="Salary Rule Search"
        [activeFilters]="activeFilterCount()"
        [resultText]="totalRecords + ' rules found'"
        [collapsed]="false"
        (search)="search()"
        (clear)="clearSearch()">
        <div class="search-grid">
            <div class="field">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-search"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <input id="rule-keyword" pInputText [(ngModel)]="keyword" placeholder="Vehicle type, currency, notes" />
                        <label for="rule-keyword">Keyword</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <div class="field">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-truck"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <p-select inputId="rule-vehicle-type" [options]="vehicleTypes" [(ngModel)]="vehicleTypeId" optionLabel="name" optionValue="id"
                            [showClear]="true" [filter]="true" filterBy="name" placeholder="Any truck type" appendTo="body" styleClass="w-full"></p-select>
                        <label for="rule-vehicle-type">Truck Type</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <div class="field">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-check-circle"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <p-select inputId="rule-active" [options]="activeOptions" [(ngModel)]="active" optionLabel="label" optionValue="value"
                            [showClear]="true" placeholder="Any active flag" appendTo="body" styleClass="w-full"></p-select>
                        <label for="rule-active">Active</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
        </div>
    </app-page-search-panel>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-data-panel title="Rule Directory" subtitle="Rules are selected by company, truck type, date, priority, and effective dates." [resultText]="totalRecords + ' total'">
        <p-table [value]="rows" [lazy]="true" [paginator]="true" [rows]="rowsPerPage" [first]="first"
            [totalRecords]="totalRecords" [loading]="isLoading" [rowsPerPageOptions]="[10, 20, 50]"
            (onLazyLoad)="loadRules($event)" styleClass="p-datatable-sm" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Truck Type</th>
                    <th>Rate</th>
                    <th>Effective Window</th>
                    <th>Priority</th>
                    <th>Active</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td class="font-semibold">{{ row.vehicleTypeName || '-' }}</td>
                    <td>{{ amountLabel(row) }} / day</td>
                    <td>{{ dateLabel(row.effectiveFrom) }} - {{ dateLabel(row.effectiveTo) }}</td>
                    <td>{{ row.priority ?? 0 }}</td>
                    <td>
                        <div class="stacked-cell">
                            <p-tag [value]="row.active === false ? 'Inactive' : 'Active'" [severity]="activeSeverity(row)"></p-tag>
                            <p-select [options]="activeOptions" [ngModel]="row.active !== false" optionLabel="label" optionValue="value"
                                appendTo="body" styleClass="w-full" [disabled]="isUpdating(row)"
                                (onChange)="updateActive(row, $event.value)"></p-select>
                        </div>
                    </td>
                    <td class="row-actions">
                        <p-button icon="pi pi-eye" [rounded]="true" [text]="true" (onClick)="view(row)" ariaLabel="View salary rule"></p-button>
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary" (onClick)="edit(row)" ariaLabel="Edit salary rule"></p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" class="empty-cell">No salary rules found.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
